// src/pages/dashboard/page.js
import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import OverviewDashboard from "./overview/page";
import SprintDashboard from "./sprintdashboard/page";

const Dashboard = () => {
  const roleId = parseInt(localStorage.getItem("roleId")); // 1=SUPERADMIN,2=ADMIN,3=EMPLOYEE,4=USER,5=HR,6=TEAM_LEAD

  const showOverview = [1, 2, 5].includes(roleId); // Admin + HR
  const showSprint   = [1, 2, 6].includes(roleId); // Admin + TeamLead

  if (showOverview && !showSprint) {
    return (
      <div style={{ padding: "16px 24px" }}>
        <OverviewDashboard />
      </div>
    );
  }

  if (showSprint && !showOverview) {
    return (
      <div style={{ padding: "16px 24px" }}>
        <SprintDashboard />
      </div>
    );
  }

  return (
    <div style={{ padding: "16px 24px" }}>
      
      <style>
        {`
          .custom-tabs .nav-tabs {
            border-bottom: 1px solid #e5e7eb;
          }

          .custom-tabs .nav-link {
            border: none !important;
            background: transparent !important;
            color: #6b7280 !important;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 16px;
            margin-right: 8px;
          }

          .custom-tabs .nav-link.active {
            color: #2563eb !important;
            font-weight: 600;
            border-bottom: 2px solid #2563eb !important;
          }

          .custom-tabs .nav-link:focus {
            box-shadow: none !important;
          }
        `}
      </style>

      <Tabs defaultActiveKey="overview" className="mb-3 custom-tabs">
        <Tab eventKey="overview" title="Overview Dashboard">
          <OverviewDashboard />
        </Tab>

        <Tab eventKey="sprint" title="Sprint Dashboard">
          <SprintDashboard />
        </Tab>
      </Tabs>

    </div>
  );
};

export default Dashboard;